import type { ScreenModule } from "../../../app/screen-module";
import { MembersPage } from "../pages";

export default {
	id: "tenant-admin.members",
	path: "/admin/members",
	area: "tenant-admin",
	navGroup: "組織",
	label: "メンバー",
	roles: ["tenant_admin", "platform_admin"],
	backing: "MOCK_ONLY",
	enabled: true,
	component: MembersPage,
} satisfies ScreenModule;
